// extracted by mini-css-extract-plugin
export default {"emptyBalance":"EmptyBalance_emptyBalance__dyFqu","image":"EmptyBalance_image__bV260","btn":"EmptyBalance_btn__j9ZWn"};